<template>
  <div id="welcome-section">
    <a href="#" @click="nextHeroState" class="minor cta-link">Next</a>

    <template v-if="heroState === 'welcome'">
      <h2>Your Brandly Dashboard</h2>
      <p>You've successfuly create a self-managing system for YOUR BRANDS business cards. While we
        firmly believe that savvy brands will want full power to control how their solutions work,
        <b>we're here to help</b>: so please tell us how we are doing and let us know if we can help
        in any way.
      </p>
      <p class="signature">-Doug Ballinger, CEO</p>
    </template>
    <template v-if="heroState === 'step1'">
      <h2>Create your account</h2>
      <p>You've completed this step already!
      </p>
    </template>
    <template v-if="heroState === 'step2'">
      <h2>Setup your portal</h2>
      <p>You've probably completed this step already! Please just continue to the next step. Let us
        know if you feel stuck in any way.
      </p>
    </template>
    <template v-if="heroState === 'step3'">
      <h2>Upload your design</h2>
      <p>What is your design? It's the PDF of <strong>your brand's</strong> business card. Upload it now and our system will convert it into an
        EDITABLE card that your whole team can use <strong>hands off</strong>. Uploading is easy: click the <q>browse</q> button, then find your PDF
        If you want extra details about the format needed, click <q>VIEW</q>
      </p>
    </template>
    <template v-if="heroState === 'step4'">
      <h2>Share with your Team</h2>
      <p>The final step! Share out your business cards with your team. Just enter their email below and press <q>invite</q>. Then your team mates
      can handle putting in an order on their own without bothering you!
      </p>
    </template>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
export default {
  computed: mapGetters(['heroState']),
  methods: mapActions(['nextHeroState'])
}
</script>

<style lang="scss" scoped>
#welcome-section {
  min-height: 180px;
}
p.signature {
  font-size: smaller;
  margin: 0 2em 0 0;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/home/WelcomeSection.vue